// TODO: deprecated — legacy AddSoundModal (radio-based 3-mode picker:
// Library / Local upload / AI). Replaced by the new tabbed AddSoundModal
// at _editor/components/add_sound_modal/AddSoundModal.jsx (AI Voice /
// Avatar / Library / Record / Upload). Still rendered in EditorModals
// under the `addSoundVisible` state. Safe to delete once every flow that
// flips `addSoundVisible` is migrated to the new modal's
// `showAddSoundModal` flow.
import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Alert from "../../common/alert/Alert";
import { Row, Col, FormGroup, FormLabel, FormControl, FormCheck, Form } from "react-bootstrap";
import AppModal from "../../common/modal/AppModal";
import { Typeahead } from "react-bootstrap-typeahead";
import {
  ID_PREFIX_RICH_MARK,
  ID_PREFIX_SORTABLE_BOX,
  ID_PREFIX_CONTAINED_VIEW,
  PAGE_TYPES,
  ID_PREFIX_PAGE,
  ID_PREFIX_BOX,
} from "../../../../common/constants";
import i18n from "i18next";
import { isSection, isContainedView, nextAvailName } from "../../../../common/utils";
import "../rich_marks_modal/_richMarksModal.scss";
import IdealStudio from "../../../../core/editor/main";

import TemplatesModalRich from "../templates_modal/TemplatesModalRich";
import { createBox } from "../../../../common/common_tools";
import AudioPlayer from "../audio-player/AudioPlayer";
import { timesSeries } from "async";
import { getToken } from "../../../../common/environment_config";
/**
 * Modal component to edit marks' configuration
 */
export default class AddSoundModal extends Component {
  /**
   * Constructor
   * @param props
   */

  constructor(props) {
    super(props);
    /**
     * Component's initial state
     * @type {{connectMode: string, displayMode: string, newSelected: string, existingSelected: string, newType: string, viewNames: *, showAlert: boolean}}
     */
    this.state = {
      connectMode: "new",
      displayMode: "navigate",
      newSelected: this.props.navItems[this.props.navItemSelected]
        ? this.props.navItems[this.props.navItemSelected].type
        : "",
      existingSelected: "",
      soundNameForList: "Beethoven-Symphony9.mp3",
      soundNameForLocal: "",
      startTime: 0,
      endTime: 0,
      volume: 1.0,
      fileSrcForList:
        "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/sound/Beethoven-Symphony9.mp3",
      fileSrcForLocal: "",
      fileSelectType: 0,
      fileFromLocal: null,
      generatedAiFile: "",
      processingAiSound: false,
      isValidAiSound: false,
      availableVoices: [],
      loadingVoices: false,
      selectedProvider: "azure",
      selectedLanguage: "en-US",
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleTemplatesModal = this.toggleTemplatesModal.bind(this);
    this.templateClick = this.templateClick.bind(this);

    this.audio = null;
    this.fileInput = React.createRef();

    this.tts_aiNameChangedAddSound = this.tts_aiNameChangedAddSound.bind(this);
    this.tts_aiLangChangedAddSound = this.tts_aiLangChangedAddSound.bind(this);

    this.ttsGenerateSoundHandlerAddSound = this.ttsGenerateSoundHandlerAddSound.bind(this);
    this.radioChecked = this.radioChecked.bind(this);
    this.fetchVoices = this.fetchVoices.bind(this);
  }

  /**
   * Before component receives props
   * Updates component's state with toolbar's state info
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    if (this.props.values != nextProps.values && nextProps.values != null) {
      this.props.ttsGetSoundMetaFile(
        { soundfileurl: nextProps.values.file },
        (isSuccess, errorStr, _metaJson) => {
          if (isSuccess == true) {
            // Normalize VoiceServiceType to consistent string values
            if (_metaJson.VoiceServiceType === "Microsoft" || _metaJson.VoiceServiceType === 0) {
              _metaJson.VoiceServiceType = "azure";
            } else if (_metaJson.VoiceServiceType === 1) {
              _metaJson.VoiceServiceType = "elevenlabs";
            } else if (_metaJson.VoiceServiceType === 2) {
              _metaJson.VoiceServiceType = "gemini";
            } else if (_metaJson.VoiceServiceType === 4) {
              _metaJson.VoiceServiceType = "sestek";
            }

            // Keep original language codes for API compatibility
            // Don't modify the language codes as they need to match what was originally stored

            // Check if this is an AI-generated sound with valid voice data
            if (
              _metaJson.VoiceServiceType &&
              _metaJson.VoiceName &&
              _metaJson.VoiceName.length > 0 &&
              _metaJson.VoiceText &&
              _metaJson.VoiceText.trim() !== ""
            ) {
              // This is an AI-generated sound, switch to AI tab
              this.setState({ fileSelectType: 2, isValidAiSound: true });

              document.getElementById("tts_prompttext").value = _metaJson.VoiceText;

              // Map provider string to numeric value for UI
              const providerToNumeric = {
                azure: "0",
                elevenlabs: "1",
                gemini: "2",
                sestek: "4",
              };

              const numericProvider = providerToNumeric[_metaJson.VoiceServiceType] || "0";

              // Set provider dropdown
              document.getElementById("tts_ainame").value = numericProvider;
              this.tts_aiNameChangedAddSound();

              // Set language dropdown — exact match first, then prefix fallback
              const langEl = document.getElementById("tts_lang");
              if (langEl && _metaJson.VoiceLanguage) {
                const profileLang = _metaJson.VoiceLanguage;
                const opts = Array.from(langEl.options);
                const exact = opts.find((o) => o.value === profileLang);
                const prefix = opts.find((o) => o.value.startsWith(profileLang.split("-")[0]));
                const best = exact || prefix || opts[0];
                if (best) langEl.value = best.value;
              }

              // Load voices for the matched language, then set the voice
              const resolvedLang = langEl ? langEl.value : _metaJson.VoiceLanguage;
              this.fetchVoices(_metaJson.VoiceServiceType, resolvedLang).then(() => {
                // Set voice after voices are loaded
                setTimeout(() => {
                  document.getElementById("tts_voice").value = _metaJson.VoiceName;
                }, 100);
              });
            } else {
              // If not an AI-generated sound, stay on default tab
              this.setState({ isValidAiSound: false });
            }
          } else {
            // If getting meta file fails, stay on default tab
            this.setState({ isValidAiSound: false });
          }
        }
      );

      this.setState(
        {
          fileSrcForList: nextProps.values.file,
          soundNameForList: nextProps.values.name,
          startTime: nextProps.values.startTime,
          endTime: nextProps.values.endTime,
          volume: nextProps.values.volumeLevel,
        },
        () => {
          if (this.state.endTime == 0) {
            this.setSoundDuration(nextProps.values.file);
          }
        }
      );
    }

    if (!this.props.visible && nextProps.visible) {
      this.setState({
        fileSelectType: 0,
        isValidAiSound: false,
      });
    }
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    let fileSrc =
      this.state.fileSelectType == 0 ? this.state.fileSrcForList : this.state.fileSrcForLocal;

    const handleCancelLegacy = () => {
      this.props.onAddSoundModalToggled();
      this.setState({
        fileSrcForList:
          "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/sound/Beethoven-Symphony9.mp3",
        soundNameForList: "Beethoven-Symphony9.mp3",
        startTime: 0,
        volume: 1.0,
        fileSelectType: 0,
        fileFromLocal: null,
        fileSrcForLocal: "",
        isValidAiSound: false,
      });
    };
    const handleAddLegacy = () => {
      if (
        (this.state.fileSelectType == 1 && this.state.fileFromLocal == null) ||
        (this.state.fileSelectType == 2 &&
          (this.state.generatedAiFile == null || this.state.generatedAiFile == ""))
      ) {
        this.props.onServerModal(
          i18n.t("FileModal.APIProviders.error"),
          i18n.t("Lütfen ses dosyası yükleyiniz"),
          false
        );
        return;
      } else if (this.state.startTime >= this.state.endTime || this.state.endTime == 0) {
        this.props.onServerModal(
          i18n.t("FileModal.APIProviders.error"),
          i18n.t("Lütfen geçerli bir süre giriniz"),
          false
        );
        return;
      }
      let fileSrc =
        this.state.fileSelectType == 0 || this.state.fileSelectType == 2
          ? this.state.fileSrcForList
          : this.state.fileSrcForLocal;
      let soundName =
        this.state.fileSelectType == 0 || this.state.fileSelectType == 2
          ? this.state.soundNameForList
          : this.state.soundNameForLocal;
      const addFunction = (fileUrl) => {
        if (this.props.values != null) {
          this.props.editSound({
            file: fileUrl,
            name: soundName,
            startTime: this.state.startTime,
            endTime: this.state.endTime,
            volumeLevel: this.state.volume,
          });
        } else {
          this.props.addSound({
            file: fileUrl,
            name: soundName,
            startTime: this.state.startTime,
            endTime: this.state.endTime,
            volumeLevel: this.state.volume,
          });
        }
        this.props.onAddSoundModalToggled();
        this.setState({
          fileSrcForList:
            "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/sound/Beethoven-Symphony9.mp3",
          soundNameForList: "Beethoven-Symphony9.mp3",
          startTime: 0,
          volume: 1.0,
          fileSelectType: 0,
          fileFromLocal: null,
          fileSrcForLocal: "",
          isValidAiSound: false,
        });
      };
      if (this.state.fileSelectType == 0 || this.state.fileSelectType == 2) {
        addFunction(fileSrc);
      } else if (this.state.fileSelectType == 1) {
        let _loading = document.getElementById("_loading");
        if (_loading != null && _loading.style !== undefined) {
          _loading.style.display = "block";
        }
        let overlay = document.getElementById("_overlay");
        if (overlay != null && overlay.style !== undefined) {
          overlay.style.display = "block";
        }
        this.props.uploadFunction(this.state.fileFromLocal, null, (url) => {
          addFunction(url);
          let loading = document.getElementById("_loading");
          if (_loading != null && _loading.style !== undefined) {
            loading.style.display = "none";
          }
          let overlay2 = document.getElementById("_overlay");
          if (overlay2 != null && overlay2.style !== undefined) {
            overlay2.style.display = "none";
          }
        });
      }
    };

    return (
      <AppModal
        className="richMarksModal"
        backdrop
        size="lg"
        show={this.props.visible}
        onClose={handleCancelLegacy}
        title={
          <>
            <i style={{ fontSize: "18px" }} className="material-icons">
              playlist_add
            </i>{" "}
            {i18n.t("Sound.add_sound")}
          </>
        }
        cancelLabel={i18n.t("Cancel")}
        onCancel={handleCancelLegacy}
        confirmLabel={i18n.t("Sound.Add")}
        onConfirm={handleAddLegacy}
      >
        <Row style={{ display: "flex", alignItems: "center", gap: "24px" }}>
          <FormCheck
            type="radio"
            id="fileType_0"
            checked={this.state.fileSelectType == 0}
            onChange={(e) => this.radioChecked(e, 0)}
            inline
            name="fileType"
            className="radio-15em"
            label={i18n.t("Sound.AddNewSoundFromList")}
          />

          <FormCheck
            type="radio"
            id="fileType_1"
            checked={this.state.fileSelectType == 1}
            onChange={(e) => this.radioChecked(e, 1)}
            inline
            name="fileType"
            className="radio-15em"
            label={i18n.t("Sound.AddNewSoundFromLocal")}
          />

          <FormCheck
            type="radio"
            id="fileType_2"
            checked={this.state.fileSelectType == 2}
            onChange={(e) => this.radioChecked(e, 2)}
            inline
            name="fileType"
            className="radio-15em"
            label={i18n.t("Sound.AddAISound") || "Yapay Zeka ile Ses Ekle"}
          />
        </Row>
        <Row style={{ margin: "0px" }}>
          <hr style={{ margin: "0px", marginBottom: "10px", borderColor: "#888" }} />
        </Row>
        {/* <Row>
            <Col xs={5} md={5}>
              <FormLabel>{i18n.t("Sound.sound_name")}</FormLabel>
            </Col>
            <Col xs={6} md={6}>
              <FormControl
                type="text"
                placeholder={i18n.t("Sound.sound_name_holder")}
                value={this.state.soundName}
                onChange={(e) => this.setState({ soundName: e.target.value })}
              ></FormControl>
            </Col>
          </Row> */}
        <Row hidden={this.state.fileSelectType != 2}>
          <div>
            <Row>
              <Col md={2}>
                <FormLabel>Ses Metni</FormLabel>
              </Col>
              <Col md={10}>
                <textarea
                  id="tts_prompttext"
                  maxLength={4096}
                  className="form-control"
                  style={{ height: "180px", width: "100%", marginBottom: "0px" }}
                />
              </Col>
            </Row>
            <Row style={{ paddingTop: "10px" }}>
              <Col md={2}>
                <FormLabel>Servis</FormLabel>
              </Col>
              <Col md={3}>
                <select
                  id="tts_ainame"
                  className="form-control"
                  onChange={(e) => {
                    this.tts_aiNameChangedAddSound();
                  }}
                  style={{ width: "100%" }}
                >
                  {/* "Sestek" (value 4) sağlayıcı seçeneği gizlendi — ai_config'ten
                      silinmedi, render'da filtrelendi. Geri açmak için filtreyi kaldır. */}
                  {window.ai_speech_conf
                    .filter((a) => Number(a.value) !== 4)
                    .map((a) => (
                      <option key={a.name} value={a.value}>
                        {a.name}
                      </option>
                    ))}
                </select>
              </Col>
              <Col md={2} id="tts_lang_col_select">
                <select
                  id="tts_lang"
                  className="form-control"
                  onChange={(e) => {
                    this.tts_aiLangChangedAddSound();
                  }}
                  style={{ width: "100%" }}
                >
                  <option>_</option>
                </select>
              </Col>
              <Col md={4} id="tts_voice_col_select">
                <select
                  id="tts_voice"
                  className="form-control"
                  style={{ width: "100%" }}
                  disabled={this.state.loadingVoices}
                >
                  {this.state.loadingVoices ? (
                    <option>Loading voices...</option>
                  ) : (
                    <option>Select voice...</option>
                  )}
                </select>
              </Col>
              <Col md={1} id="tts_voice_col_create">
                <button
                  type="button"
                  id="tts_createfile"
                  className="app-modal__btn app-modal__btn--primary"
                  disabled={window.ai_speech_conf.length == 0 || this.state.processingAiSound}
                  onClick={(e) => {
                    this.ttsGenerateSoundHandlerAddSound(e);
                  }}
                >
                  {i18n.t("Create")}
                </button>
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <FormLabel>&nbsp;</FormLabel>
              </Col>
              <Col md={3}>
                <FormLabel>&nbsp;</FormLabel>
              </Col>
              <Col md={7}>
                <h6 id="tts_usage" className={this.state.processingAiSound == true ? "" : "hidden"}>
                  {i18n.t("PleaseWait") || "Lütfen Bekleyin..."}
                </h6>
                <h6 id="tts_usage" className="hidden" />
              </Col>
            </Row>
          </div>
          <hr style={{ margin: "0px", borderTopColor: "#888" }} />
        </Row>
        <Row
          hidden={
            this.state.fileSelectType == 2 &&
            !this.state.isValidAiSound &&
            this.state.generatedAiFile == ""
          }
        >
          <Col xs={5} md={5}>
            <FormLabel>{i18n.t("Sound.select_sound")}</FormLabel>
          </Col>
          <Col xs={6} md={6}>
            {this.state.fileSelectType == 0 ? (
              <FormControl
                as="select"
                onChange={(e) => {
                  this.setState(
                    {
                      fileSrcForList: e.target.value,
                      soundNameForList: e.target.options[e.target.selectedIndex].text,
                    },
                    () => {
                      this.setSoundDuration(this.state.fileSrcForList);
                    }
                  );
                }}
                value={this.state.fileSrcForList}
              >
                {(this.props.soundList && Array.isArray(this.props.soundList)
                  ? this.props.soundList
                  : []
                )
                  .sort((a, b) => b.id.localeCompare(a.id))
                  .map((sound) => (
                    <option key={sound.url} value={sound.url}>
                      {sound.name}
                    </option>
                  ))}
              </FormControl>
            ) : this.state.fileSelectType == 2 ? (
              <h5>{this.state.soundNameForList}</h5>
            ) : (
              <button
                type="button"
                className="app-modal__btn app-modal__btn--primary"
                style={{ overflow: "auto", width: "100%" }}
                onClick={() => {
                  this.fileInput.current.click();
                }}
                title={
                  this.state.fileFromLocal != null
                    ? this.state.fileFromLocal.name
                    : i18n.t("Sound.NoFileChosen")
                }
              >
                {this.state.fileFromLocal != null
                  ? this.state.fileFromLocal.name
                  : i18n.t("Sound.NoFileChosen")}
              </button>
            )}
            <input
              ref={this.fileInput}
              type="file"
              accept=".mp3"
              style={{ display: "none" }}
              onChange={(event) =>
                this.setState({ fileFromLocal: event.target.files[0] }, () => {
                  this.setState(
                    {
                      fileSrcForLocal:
                        this.state.fileFromLocal != null
                          ? URL.createObjectURL(this.state.fileFromLocal)
                          : "",
                      soundNameForLocal:
                        this.state.fileFromLocal != null ? this.state.fileFromLocal.name : "",
                    },
                    () => {
                      this.setSoundDuration(this.state.fileSrcForLocal);
                    }
                  );
                })
              }
            />
          </Col>
        </Row>
        <Row
          hidden={
            this.state.fileSelectType == 2 &&
            !this.state.isValidAiSound &&
            this.state.generatedAiFile == ""
          }
        >
          <Col xs={5} md={5}>
            <FormLabel>{i18n.t("Sound.DemoSound")}</FormLabel>
          </Col>
          <Col xs={6} md={6}>
            <AudioPlayer
              modalVisible={this.props.visible}
              volume={this.state.volume}
              duration={this.state.endTime - this.state.startTime}
              file={
                this.state.fileSelectType == 1
                  ? this.state.fileFromLocal != null
                    ? URL.createObjectURL(this.state.fileFromLocal)
                    : null
                  : this.state.fileSrcForList
              }
            />
          </Col>
        </Row>

        <Row
          hidden={
            this.state.fileSelectType == 2 &&
            !this.state.isValidAiSound &&
            this.state.generatedAiFile == ""
          }
        >
          <Col xs={5} md={5}>
            <FormLabel>{i18n.t("AudioCue.StartTime")}</FormLabel>
          </Col>
          <Col xs={6} md={6}>
            <FormControl
              style={{ width: "120px" }}
              type="number"
              min="0"
              defaultValue="0"
              value={this.state.startTime}
              step="1"
              onChange={(e) => {
                this.setState({ startTime: Number(e.target.value) }, () => {});
              }}
            />
          </Col>
        </Row>
        <Row
          hidden={
            this.state.fileSelectType == 2 &&
            !this.state.isValidAiSound &&
            this.state.generatedAiFile == ""
          }
        >
          <Col xs={5} md={5}>
            <FormLabel>{i18n.t("AudioCue.EndTime")}</FormLabel>
          </Col>
          <Col xs={6} md={6}>
            <FormControl
              style={{ width: "120px" }}
              type="number"
              min="0"
              defaultValue={this.state.endTime}
              value={this.state.endTime}
              step="1"
              onChange={(e) => {
                this.setState({ endTime: Number(e.target.value) });
              }}
            />
          </Col>
        </Row>
        <Row
          hidden={
            this.state.fileSelectType == 2 &&
            !this.state.isValidAiSound &&
            this.state.generatedAiFile == ""
          }
        >
          <Col xs={5} md={5}>
            <FormLabel>{i18n.t("Sound.VolumeLevel")}</FormLabel>
          </Col>
          <Col xs={6} md={6}>
            <input
              min="0"
              max="100"
              step="1"
              defaultValue={this.state.volume * 100}
              onChange={(e) => this.setState({ volume: Number(e.target.value) / 100 })}
              type="range"
            />
            <label
              style={{
                width: "100%",
                textAlign: "center",
                transformOrigin: "center",
              }}
            >
              {Math.ceil(this.state.volume * 100)}
            </label>
          </Col>
        </Row>
        <Alert
          className="pageModal"
          show={this.state.showAlert}
          hasHeader
          title={i18n.t("marks.wrong_value")}
          closeButton
          onClose={() => {
            this.setState({ showAlert: false });
          }}
        >
          <span> {this.state.alertMsg} </span>
        </Alert>
      </AppModal>
    );
  }

  radioChecked(evt, _type) {
    if (_type == 1) {
      this.setState({ fileSelectType: 1 }, () => {
        let fileSrc =
          this.state.fileSelectType == 0 ? this.state.fileSrcForList : this.state.fileSrcForLocal;

        this.setSoundDuration(fileSrc);
      });
    } else if (_type == 2) {
      this.setState({ fileSelectType: 2 }, () => {
        if (window.ai_speech_conf.length > 0) {
          if (
            this.props.values === null &&
            this.props.voiceProfile &&
            this.props.voiceProfile.voiceName
          ) {
            this.applyVoiceProfile();
          } else if (document.getElementById("tts_lang").value == "_") {
            this.tts_aiNameChangedAddSound();
          }
        } else {
          this.tts_aiNameChangedAddSound();
        }
        if (window.ai_speech_conf.length > 0) {
          /* if (aiSelectedVoiceServiceType > -1 && aiSelectedVoiceName.length > 0) {

                        let aisType = window.ai_speech_conf.find(a => a.value == aiSelectedVoiceServiceType);
                        if (aisType != null) {
                            for (let index = 0; index < aisType.lang.length; index++) {
                                let aiLang = aisType.lang[index];

                                if (aiLang.voices.filter(a => a.value == aiSelectedVoiceName).length > 0) {
                                    document.getElementById("tts_ainame").value = aiSelectedVoiceServiceType;
                                    aiSelectedVoiceLang = aiLang.name;

                                    this.tts_aiNameChangedAddSound();
                                    // set lang
                                    document.getElementById("tts_lang").value = aiSelectedVoiceLang;
                                    this.tts_aiLangChangedAddSound();
                                    // set voice
                                    document.getElementById("tts_voice").value = aiSelectedVoiceName;
                                    break;
                                }
                            }
                        }
                    }*/
        }
        let fileSrc =
          this.state.fileSelectType == 2 ? this.state.fileSrcForList : this.state.fileSrcForLocal;

        this.setSoundDuration(fileSrc);
      });
    } else {
      this.setState({ fileSelectType: 0 }, () => {
        let fileSrc =
          this.state.fileSelectType == 0 ? this.state.fileSrcForList : this.state.fileSrcForLocal;

        this.setSoundDuration(fileSrc);
      });
    }
  }

  setSoundDuration(src) {
    if (src != "") {
      let audio = new Audio();

      audio.src = src;

      audio.onloadeddata = () => {
        if (audio.duration === Infinity) {
          audio.currentTime = 10000000 * Math.random();
        } else {
          this.setState({
            endTime: Math.ceil(audio.duration),
          });
        }
      };

      audio.ontimeupdate = () => {
        this.setState({
          endTime: Math.ceil(audio.duration),
        });
      };
    } else {
      this.setState({
        endTime: 0,
      });
    }
  }

  componentDidMount() {
    window.addEventListener("keyup", this.toggleModal);

    this.setSoundDuration(this.state.fileSrcForList);
  }

  componentWillUnmount() {
    window.removeEventListener("keyup", this.toggleModal);
  }

  toggleModal(e) {
    let key = e.keyCode ? e.keyCode : e.which;
    if (key === 27 && this.props.visible) {
      this.props.onAddSoundModalToggled();
    }
  }

  toggleTemplatesModal() {
    this.setState((prevState, props) => ({
      showTemplates: !prevState.showTemplates,
    }));
  }
  templateClick(boxes) {
    this.setState({
      boxes: boxes,
    });
  }

  restoreDefaultTemplate() {
    this.setState({
      boxes: [],
    });
  }

  applyVoiceProfile() {
    const profile = this.props.voiceProfile;
    if (!profile || !profile.voiceName) {
      this.tts_aiNameChangedAddSound();
      return;
    }

    const provider = profile.voiceServiceProvider || "azure";

    // Set provider dropdown
    const aiNameEl = document.getElementById("tts_ainame");
    if (aiNameEl) aiNameEl.value = String(profile.voiceServiceType);

    // Build language dropdown inline (same lists as tts_aiNameChangedAddSound)
    // without triggering the internal fetchVoices("en-US") call
    const langSelect = document.getElementById("tts_lang");
    const langCol = document.getElementById("tts_lang_col_select");
    if (langSelect) {
      langSelect.innerHTML = "";
      let langList = [];
      if (provider === "azure") {
        langList = [
          {
            code: "en-US",
            name: `${i18n.t("languages.English") || "English"} (US)`,
          },
          {
            code: "en-GB",
            name: `${i18n.t("languages.English") || "English"} (UK)`,
          },
          { code: "tr-TR", name: i18n.t("languages.Turkish") || "Turkish" },
          { code: "de-DE", name: i18n.t("languages.German") || "German" },
          { code: "fr-FR", name: i18n.t("languages.French") || "French" },
          { code: "ar-SA", name: i18n.t("languages.Arabic") || "Arabic" },
          { code: "az-AZ", name: i18n.t("languages.Azerbaijani") || "Azerbaijani" },
          { code: "ja-JP", name: i18n.t("languages.Japanese") || "Japanese" },
        ];
        if (langCol) langCol.classList.remove("hidden");
      } else if (provider === "gemini") {
        langList = [
          {
            code: "en-US",
            name: `${i18n.t("languages.English") || "English"} (US)`,
          },
          { code: "tr-TR", name: i18n.t("languages.Turkish") || "Turkish" },
          { code: "de-DE", name: i18n.t("languages.German") || "German" },
          { code: "fr-FR", name: i18n.t("languages.French") || "French" },
          { code: "ar-SA", name: i18n.t("languages.Arabic") || "Arabic" },
          { code: "az-AZ", name: i18n.t("languages.Azerbaijani") || "Azerbaijani" },
          { code: "ja-JP", name: i18n.t("languages.Japanese") || "Japanese" },
        ];
        if (langCol) langCol.classList.remove("hidden");
      } else {
        langList = [{ code: "en-US", name: i18n.t("languages.English") || "English" }];
        if (langCol) langCol.classList.add("hidden");
      }

      langList.forEach((lang) => {
        const option = document.createElement("option");
        option.value = lang.code;
        option.innerHTML = lang.name;
        langSelect.add(option);
      });

      // Best-match profile.voiceLanguage to an available option:
      // exact match first, then find an option whose code starts with the same prefix
      const profileLang = profile.voiceLanguage || "";
      const options = Array.from(langSelect.options);
      const exact = options.find((o) => o.value === profileLang);
      const prefix = options.find((o) =>
        profileLang ? o.value.startsWith(profileLang.split("-")[0]) : false
      );
      const best = exact || prefix || options[0];
      if (best) langSelect.value = best.value;
    }

    // Single fetchVoices call for the matched language, then pre-select the voice
    const matchedLanguage = langSelect ? langSelect.value : profile.voiceLanguage || "en-US";
    this.fetchVoices(provider, matchedLanguage).then(() => {
      setTimeout(() => {
        const voiceEl = document.getElementById("tts_voice");
        if (voiceEl && profile.voiceName) {
          voiceEl.value = profile.voiceName;
        }
      }, 100);
    });
  }

  async fetchVoices(provider = null, language = null) {
    const currentProvider = provider || this.state.selectedProvider;
    const currentLanguage = language || this.state.selectedLanguage;

    this.setState({ loadingVoices: true });

    try {
      const token = getToken();
      const response = await fetch(
        `${process.env.MW_API_URL}api/ideal-studio/tts-voices/${currentProvider}?language=${currentLanguage}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        const voices = await response.json();
        console.log("Fetched voices:", voices);
        this.setState({
          availableVoices: voices,
          loadingVoices: false,
          selectedProvider: currentProvider,
          selectedLanguage: currentLanguage,
        });

        this.updateVoiceSelect(voices);
      } else {
        console.error("Failed to fetch voices:", response.status);
        this.setState({ loadingVoices: false });
      }
    } catch (error) {
      console.error("Error fetching voices:", error);
      this.setState({ loadingVoices: false });
    }
  }

  updateVoiceSelect(voices) {
    const voiceSelect = document.getElementById("tts_voice");
    if (voiceSelect) {
      voiceSelect.innerHTML = "";

      voices.forEach((voice) => {
        console.log("Processing voice:", voice);
        const option = document.createElement("option");
        // Use the correct ID field for the voice value
        option.value = voice.id || voice.voice_id || voice.ShortName || voice.value || voice.name;
        option.innerHTML = voice.name || voice.DisplayName || voice.displayName || option.value;
        voiceSelect.add(option);
      });
    }
  }

  tts_aiNameChangedAddSound() {
    const selectedProvider = document.getElementById("tts_ainame").value;
    const providerMap = {
      0: "azure",
      1: "elevenlabs",
      2: "gemini",
      4: "sestek",
    };

    const provider = providerMap[selectedProvider] || "azure";

    if (document.getElementById("tts_lang")) {
      document.getElementById("tts_lang").innerHTML = "";

      const langSelect = document.getElementById("tts_lang");

      if (provider === "azure") {
        const languages = [
          {
            code: "en-US",
            name: `${i18n.t("languages.English") || "English"} (US)`,
          },
          {
            code: "en-GB",
            name: `${i18n.t("languages.English") || "English"} (UK)`,
          },
          { code: "tr-TR", name: i18n.t("languages.Turkish") || "Turkish" },
          { code: "de-DE", name: i18n.t("languages.German") || "German" },
          { code: "fr-FR", name: i18n.t("languages.French") || "French" },
          { code: "ar-SA", name: i18n.t("languages.Arabic") || "Arabic" },
          { code: "az-AZ", name: i18n.t("languages.Azerbaijani") || "Azerbaijani" },
          { code: "ja-JP", name: i18n.t("languages.Japanese") || "Japanese" },
        ];

        languages.forEach((lang) => {
          const option = document.createElement("option");
          option.value = lang.code;
          option.innerHTML = lang.name;
          langSelect.add(option);
        });

        document.getElementById("tts_lang_col_select").classList.remove("hidden");
      } else if (provider === "elevenlabs") {
        const languages = [
          {
            code: "en-US",
            name: `${i18n.t("languages.English") || "English"} (US)`,
          },
          { code: "tr-TR", name: i18n.t("languages.Turkish") || "Turkish" },
          { code: "de-DE", name: i18n.t("languages.German") || "German" },
          { code: "fr-FR", name: i18n.t("languages.French") || "French" },
          { code: "ar-SA", name: i18n.t("languages.Arabic") || "Arabic" },
          { code: "az-AZ", name: i18n.t("languages.Azerbaijani") || "Azerbaijani" },
          { code: "ja-JP", name: i18n.t("languages.Japanese") || "Japanese" },
        ];

        languages.forEach((lang) => {
          const option = document.createElement("option");
          option.value = lang.code;
          option.innerHTML = lang.name;
          langSelect.add(option);
        });

        document.getElementById("tts_lang_col_select").classList.remove("hidden");
      } else if (provider === "gemini") {
        const languages = [
          { code: "en-US", name: i18n.t("languages.English") || "English" },
          { code: "tr-TR", name: i18n.t("languages.Turkish") || "Turkish" },
          { code: "de-DE", name: i18n.t("languages.German") || "German" },
          { code: "fr-FR", name: i18n.t("languages.French") || "French" },
          { code: "ar-SA", name: i18n.t("languages.Arabic") || "Arabic" },
          { code: "az-AZ", name: i18n.t("languages.Azerbaijani") || "Azerbaijani" },
          { code: "ja-JP", name: i18n.t("languages.Japanese") || "Japanese" },
        ];

        languages.forEach((lang) => {
          const option = document.createElement("option");
          option.value = lang.code;
          option.innerHTML = lang.name;
          langSelect.add(option);
        });

        document.getElementById("tts_lang_col_select").classList.remove("hidden");
      } else {
        const defaultOption = document.createElement("option");
        defaultOption.value = "en-US";
        defaultOption.innerHTML = "English";
        langSelect.add(defaultOption);

        document.getElementById("tts_lang_col_select").classList.add("hidden");
      }

      this.fetchVoices(provider, "en-US");
    }
  }

  tts_aiLangChangedAddSound() {
    if (document.getElementById("tts_lang")) {
      const selectedProvider = document.getElementById("tts_ainame").value;
      const selectedLanguage = document.getElementById("tts_lang").value;

      const providerMap = {
        0: "azure",
        1: "elevenlabs",
        2: "gemini",
        4: "sestek",
      };

      const provider = providerMap[selectedProvider] || "azure";

      this.fetchVoices(provider, selectedLanguage);
    }
  }

  ttsGenerateSoundHandlerAddSound(e) {
    let _prompt = document.getElementById("tts_prompttext").value;
    let _selectedName = document.getElementById("tts_ainame").value;
    let _selectedLang = document.getElementById("tts_lang").value;
    let _selectedVoice = document.getElementById("tts_voice").value;

    if (_prompt.replaceAll(" ", "") == "") {
      this.props.onServerModal(
        i18n.t("error.warning"),
        "<span>" + i18n.t("YouMustEnterAVoiceoverText") + "</span>",
        false
      );
      return;
    }

    let idd = "file-" + Date.now();
    let fnamee = "AI-" + _prompt;
    if (_prompt.length > 50) {
      fnamee = "AI-" + _prompt.substr(0, 50);
    }

    this.props.ttsGenerateSoundFile(
      {
        prompt: _prompt,
        aiType: _selectedName,
        langName: _selectedLang,
        voiceName: _selectedVoice,
        id: idd,
        fileName: fnamee,
      },
      (isSuccess, errorStr, fileUrl, subscriptionUsed, subscriptionLimit) => {
        if (isSuccess && fileUrl != "") {
          this.setState(
            {
              processingAiSound: false,
              generatedAiFile: fileUrl,
              fileSrcForList: fileUrl,
              soundNameForList: fnamee,
              isValidAiSound: true,
            },
            () => {
              this.setSoundDuration(fileUrl);
            }
          );
          //this.props.onElementSelected(fnamee, fileUrl, "audio", idd);
        } else {
          this.props.onServerModal(
            i18n.t("FileModal.APIProviders.error"),
            "<span>" + errorStr + "</span>",
            false
          );
          this.setState({ processingAiSound: false, generatedAiFile: "", isValidAiSound: false });
        }
      }
    );
    this.setState({ processingAiSound: true, generatedAiFile: "" });
    e.stopPropagation();
  }
}

AddSoundModal.propTypes = {
  //navItemSelected: PropTypes.any.isRequired,
  /**
   * Selected contained view
   */
  containedViewSelected: PropTypes.any.isRequired,
  /**
   * Object containing all contained views (identified by its ID)
   */
  containedViews: PropTypes.object.isRequired,
  /**
   * Object containing all views (by id)
   */

  visible: PropTypes.any.isRequired,
  /**
   * Mark currently being edited
   */

  onAddSoundModalToggled: PropTypes.any.isRequired,
  /**
   * Cursor value when creating mark (coordinates)
   */

  onIndexSelected: PropTypes.func,
  /**
   * Contains the id of the selected template
   */
  indexSelected: PropTypes.func,
};
